import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import homeBg from "../../images/home-bg.png";
import bannerPhone from "../../images/banner-phone.png";
import processImg1 from "../../images/process-img1.png";
import processImg2 from "../../images/process-img2.png";
import processImg3 from "../../images/process-img3.png";
import notifyBg from "../../images/notify-bg.png";
import headerLogo from "../../images/header-logo.png";
import footerLogo from "../../images/footer-logo.png";
import { notifyMe } from "../../Redux/actions/notifyMe";
import AppStoreButton from "../../images/app-store.svg";
import PlayStoreButton from "../../images/play-store.svg";
import "./Home.scss";
import validator from "validator";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Home: React.FC = () => {
  toast.configure();
  const dispatch = useDispatch();
  const [email, setEmail] = useState("");
  const [EmailError, setEmailError] = useState("");
  const onSubmit = async (email: string) => {
    // setEmail(email)
    console.log(email);

    if (email.length > 0 && validator.isEmail(email)) {
      setEmailError("");
      const response: any = await dispatch(notifyMe(email));
      console.log("jdhwjhdwj", response.data);

      if (response.data.message === "email entered") {
        toast("Thanks for registration, Stay Tuned for updates");
        // setEmail("")
      } else if (response.data.message === "Email Already used") {
        toast("Hey, you are already registered for the app!");
        // setEmail("")
      }
    } else {
      setEmailError("Enter Correct Email");
    }
  };
  const HandleChange = (event: any) => {
    const emailValue = event.target.value;

    setEmail(emailValue);
  };

  return (
    <div className="home-page">
      {/* home-header start */}
      <header className="home-header">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-6 col-sm-5">
              <div className="header-logo">
                <a href="javascript:;">
                  <img src={headerLogo} />
                </a>
              </div>
            </div>
            <div className="col-md-6 col-sm-7">
              <div className="header-links">
                <ul>
                  <li>
                    <a href="#homeAbout">About</a>
                  </li>
                  {/* <li>
                    <a
                      href="#notifyForm"
                      className="theme-button primary-btn radius-btn"
                    >
                      Notify Me
                    </a>
                  </li> */}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </header>
      {/* home-header end */}

      <section
        className="home-banner-section"
        style={{ backgroundImage: `url(${homeBg})` }}
      >
        <div className="home-banner-inner">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-md-6">
                <div className="content">
                  <h1>
                    Meet Others<br></br> Who Live,<br></br> Love and Laugh
                  </h1>
                  <p>
                    Amour provides a true love/life experience. We meet your
                    needs on a personal level. Sign up to be notified when our
                    Amour community goes live…
                  </p>
                  <div className="button-align-store justify-content-start">
                    <a
                      href="https://apps.apple.com/in/app/amour-dating-app/id1620545838"
                      target="_blank"
                    >
                      <img src={AppStoreButton} alt="button" />
                    </a>
                    <a
                      href="https://play.google.com/store/apps/details?id=com.amourdating.app"
                      target="_blank"
                    >
                      <img src={PlayStoreButton} alt="button" />
                    </a>
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="phone-img">
                  <img src={bannerPhone} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Romance start */}
      <section className="home-app-process">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-6">
              <div className="process-img">
                <img src={processImg1} />
              </div>
            </div>
            <div className="col-md-6">
              <div className="process-content">
                <h2>Romance</h2>
                <p>
                  What are you looking for?<br></br> Friendship? Love? Intimacy?
                </p>
                <p>
                  We have designed this app to focus on your needs and wants.
                  Let us make your preferences be a strength and not a weakness.
                </p>
                <div className="button-align-store justify-content-start">
                  <a
                    href="https://apps.apple.com/in/app/amour-dating-app/id1620545838"
                    target="_blank"
                  >
                    <img src={AppStoreButton} alt="button" />
                  </a>
                  <a
                    href="https://play.google.com/store/apps/details?id=com.amourdating.app"
                    target="_blank"
                  >
                    <img src={PlayStoreButton} alt="button" />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Romance end */}

      {/* Companionship start */}
      <section className="home-app-process">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-6">
              <div className="process-content">
                <h2>Companionship</h2>
                <p>
                  We use a unique compatibility system based on your personal
                  wants and needs. This system gives you better than a 90%
                  chance to encounter and meet someone who strikes your interest
                  both physically, mentally and emotionally.
                </p>
                <div className="button-align-store justify-content-start">
                  <a
                    href="https://apps.apple.com/in/app/amour-dating-app/id1620545838"
                    target="_blank"
                  >
                    <img src={AppStoreButton} alt="button" />
                  </a>
                  <a
                    href="https://play.google.com/store/apps/details?id=com.amourdating.app"
                    target="_blank"
                  >
                    <img src={PlayStoreButton} alt="button" />
                  </a>
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="process-img">
                <img src={processImg2} />
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Companionship end */}

      {/* Exclusivity start */}
      <section className="home-app-process exclusivity-process">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-6">
              <div className="process-img">
                <img src={processImg3} />
              </div>
            </div>
            <div className="col-md-6">
              <div className="process-content">
                <h2>Exclusivity</h2>
                <p>
                  We respect your passion to be exclusive and private. We have
                  options within the app to maintain your level of privacy..
                </p>
                <p>
                  While still allowing you to have a little fun when you wish.
                </p>
                <div className="button-align-store justify-content-start">
                  <a
                    href="https://apps.apple.com/in/app/amour-dating-app/id1620545838"
                    target="_blank"
                  >
                    <img src={AppStoreButton} alt="button" />
                  </a>
                  <a
                    href="https://play.google.com/store/apps/details?id=com.amourdating.app"
                    target="_blank"
                  >
                    <img src={PlayStoreButton} alt="button" />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Exclusivity end */}

      {/* section-notify start */}
      <section
        className="section-notify"
        id="notifyForm"
        style={{ backgroundImage: `url(${notifyBg})` }}
      >
        <div className="container">
          <div className="content">
            <h2>
              Beautiful Singles are waiting.. start your love experience now!
            </h2>

            <div className="button-align-store">
              {/* <div className="form-group">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter your email address"
                  // defaultValue={email || }
                  onChange={(event) => HandleChange(event)}
                />
                <button
                  type="button"
                  className="theme-button primary-btn radius-btn"
                  onClick={() => {
                    onSubmit(email);
                  }}
                >
                  Notify Me
                </button>
              </div>
              <div className="message error p-0">
                <p>{EmailError}</p>
              </div> */}
              <a
                href="https://apps.apple.com/in/app/amour-dating-app/id1620545838"
                target="_blank"
              >
                <img src={AppStoreButton} alt="button" />
              </a>
              <a
                href="https://play.google.com/store/apps/details?id=com.amourdating.app"
                target="_blank"
              >
                <img src={PlayStoreButton} alt="button" />
              </a>
            </div>
          </div>
        </div>
      </section>
      {/* section-notify end */}

      {/* home-about start */}
      <section className="home-about" id="homeAbout">
        <div className="container">
          <div className="about-inner">
            <h2>About Amour</h2>
            <p>
              Amour is a compatibility based dating app geared towards your
              personal wants and needs. We offer a 90% guarantee that based on
              our system we will match you with someone you will be compatible
              with physically, mentally and emotionally. Within the app are
              other features that unlock enormous friendship, love, and intimacy
              opportunities within the Amour community.
            </p>
            <div className="social-links">
              <ul>
                <li>
                  <a
                    href="https://www.facebook.com/Amour-A-Love-Experience-101640185779228/"
                    target="_blank"
                  >
                    <i className="fab fa-facebook-f"></i>
                  </a>
                </li>
                <li>
                  <a href="https://twitter.com/amourdatingapp" target="_blank">
                    <i className="fab fa-twitter"></i>
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.instagram.com/accounts/login/?next=/amour_aha/"
                    target="_blank"
                  >
                    <i className="fab fa-instagram"></i>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
      {/* home-about end */}

      {/* home-footer start */}
      <footer className="home-footer">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-6 col-sm-12">
              <div className="footer-logo">
                <img src={footerLogo} />
              </div>
            </div>
            <div className="col-md-6 col-sm-12">
              <div className="copyright">
                <p>
                  <Link to="/term-conditions">Terms of use</Link>
                </p>
                <p>
                  <Link to="/privacy-policy">Privacy policy</Link>
                </p>
              </div>
            </div>
          </div>
          <p className="copyright-text">
            {new Date().getFullYear()} © Amour™. All Rights Reserved. Developed
            by
            <a href="https://www.biz4group.com/" target="_blank">
              {" "}
              Biz4Group LLC
            </a>
          </p>
        </div>
      </footer>
      {/* home-footer end */}
    </div>
  );
};
export default Home;
